import { useContext } from "react";
import { HistoryDetailsChannel } from "@common/constants/agent-channel";
import { ActivityOutcomeKind } from "@common/schemas/domains/activity/activity-outcomes.schema";
import { AuditChannel } from "@common/types/auditLog";
import { historyDrawerContext } from "../historyDrawerContext";
import { HistoryRow } from "../views/historyViewConfig";
import { toDetailsChannel } from "../utils/actorUtils";

interface HistoryDetailsListParams {
    channel?: HistoryDetailsChannel;
    channels?: AuditChannel[];
    outcome?: ActivityOutcomeKind;
}

/**
 * Details drawers pass the clicked row's own channel (as an explicit
 * `channel` discriminator) plus the active list `channels` and `outcome`
 * filters, so a drawer shows exactly the clicked row's changes without
 * reintroducing changes the list hid. The discriminator is only meaningful
 * when the list was fetched with `groupByChannel`; lists without it (e.g. CoA
 * template activity) carry `channel: null` on every row, so nothing is sent
 * for them.
 */
export function useHistoryDetailsListParams(
    historyRow: HistoryRow | null,
): HistoryDetailsListParams {
    const { channels, outcome, isGroupedByChannel } =
        useContext(historyDrawerContext);
    return {
        channel: isGroupedByChannel
            ? toDetailsChannel(historyRow?.channel)
            : undefined,
        channels,
        outcome,
    };
}
